// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'D:/pros/react_admin_wolf_o/my-project/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import ShopOutlined from 'D:/pros/react_admin_wolf_o/my-project/node_modules/@ant-design/icons/es/icons/ShopOutlined';
import ClusterOutlined from 'D:/pros/react_admin_wolf_o/my-project/node_modules/@ant-design/icons/es/icons/ClusterOutlined';
import AccountBookOutlined from 'D:/pros/react_admin_wolf_o/my-project/node_modules/@ant-design/icons/es/icons/AccountBookOutlined';
import GoldOutlined from 'D:/pros/react_admin_wolf_o/my-project/node_modules/@ant-design/icons/es/icons/GoldOutlined';
export default { SmileOutlined, ShopOutlined, ClusterOutlined, AccountBookOutlined, GoldOutlined };
